export default "__VITE_ASSET__DsahsSOV__"